var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGift = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100,
  fill: "none",
  viewBox: "0 0 159 159"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#gift_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "gift_svg__b",
  width: 159,
  height: 159,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 79.5,
  cy: 79.5,
  r: 79.5,
  fill: "#000"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#gift_svg__b)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 79.5,
  cy: 80.106,
  r: 78.5,
  fill: "#f3f4f6",
  stroke: "#5472cc",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b7c3ea",
  stroke: "#5472cc",
  strokeWidth: 2,
  d: "M108.35 73.76v38.812H51.793V73.76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#b7c3ea",
  stroke: "#5472cc",
  strokeWidth: 2,
  d: "M109.77 61.338v13.757H49.617V61.338z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5472cc",
  strokeWidth: 2,
  d: "M81.172 60.752v50.572M95.158 51.11a4.314 4.314 0 0 1-1.174 5.987c-1.1.74-4.214 2.152-7.287 3.076-1.529.46-2.978.776-4.111.842-.568.033-1.005 0-1.312-.08s-.394-.18-.416-.213c-.022-.032-.082-.15-.04-.465s.176-.732.421-1.245c.49-1.025 1.33-2.247 2.332-3.49 2.017-2.496 4.5-4.845 5.6-5.585a4.314 4.314 0 0 1 5.987 1.174ZM65.98 51.11a4.314 4.314 0 0 0 1.173 5.987c1.1.74 4.213 2.152 7.287 3.076 1.529.46 2.977.776 4.11.842.569.033 1.005 0 1.313-.08.307-.08.394-.18.416-.213.021-.032.081-.15.04-.465-.043-.315-.176-.732-.421-1.245-.49-1.025-1.33-2.247-2.332-3.49-2.017-2.496-4.5-4.845-5.6-5.585a4.314 4.314 0 0 0-5.987 1.174Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5472cc",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m80.016 61.559-10.295 8.77M81.105 61.432l9.061 8.683"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e9edf7",
  d: "M47.5 102.501c-10.259 2.964-21.682 25.317-26.112 36.123-5.051 4.632-15.2 15.7-15.387 22.925-.186 7.225 21.371 15.978 32.173 19.451l8.16-21.767c4.662-19.682 3.497-25.703 28.676-26.398 25.178-.694 44.995-25.008 48.259-30.334s-5.129-8.8-10.725-2.084c-4.476 5.372-14.765 9.642-19.35 11.106 3.55-1.658 3.373-3.372 2.798-5.086-1.166-3.473-10.491-2.084-19.584-2.084s-16.086-5.557-28.909-1.852"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#5472cc",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M66.85 116.394c15.119-1.525 22.698-3.169 26.344-4.871m0 0c3.55-1.658 3.373-3.372 2.798-5.086-1.166-3.473-10.491-2.084-19.584-2.084s-16.086-5.557-28.909-1.852c-10.258 2.964-21.681 25.317-26.11 36.123-5.052 4.632-15.201 15.7-15.388 22.925S27.372 177.527 38.174 181l8.16-21.767c4.662-19.682 3.497-25.703 28.676-26.398 25.178-.694 44.995-25.008 48.259-30.334s-5.129-8.8-10.725-2.084c-4.476 5.372-14.765 9.642-19.35 11.106Z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "gift_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f3f4f6",
  d: "M0 0h159v159H0z"
})))));
export default SvgGift;